<div><router-view name="nav"></router-view><router-view></router-view></div>